import React from 'react';
import PropTypes from 'prop-types';
import {ConfirmationSteps} from './ConfirmationSteps/ConfirmationSteps';
import {PaymentSteps} from './PaymentSteps/PaymentSteps';
import {ReservationSteps} from './ReservationSteps/ReservationSteps';

export class NextSteps extends React.PureComponent {
    static propTypes = {
        email: PropTypes.string,
        hostName: PropTypes.string,
        instantBooking: PropTypes.bool.isRequired,
        isIpm: PropTypes.boolean,
        isVrbexNative: PropTypes.boolean,
        isVrboIpmStaticMessaging: PropTypes.boolean,
        paymentConfirmation: PropTypes.bool.isRequired,
        reservationId: PropTypes.string,
        reservationStatus: PropTypes.string,
        translations: PropTypes.shape({}).isRequired,
        confirmation: PropTypes.shape({}),
        tripDetailsUrl: PropTypes.string.isRequired,
    };

    static defaultProps = {
        translations: {},
    };

    render() {
        const {
            email,
            instantBooking,
            paymentConfirmation,
            reservationId,
            reservationStatus,
            translations,
            confirmation,
            tripDetailsUrl,
            hostName,
            isIpm,
            isVrbexNative,
            isVrboIpmStaticMessaging,
        } = this.props;
        let next = (
            <ReservationSteps
                email={email}
                hostName={hostName}
                instantBooking={instantBooking}
                isIpm={isIpm}
                isVrbexNative={isVrbexNative}
                isVrboIpmStaticMessaging={isVrboIpmStaticMessaging}
                translations={translations}
                reservationId={reservationId}
                tripDetailsUrl={tripDetailsUrl}
            />
        );

        if (reservationStatus === 'CONFIRMED' || instantBooking) {
            next = (
                <ConfirmationSteps
                    email={email}
                    hostName={hostName}
                    isIpm={isIpm}
                    isVrboIpmStaticMessaging={isVrboIpmStaticMessaging}
                    instantBooking={instantBooking}
                    translations={translations}
                    confirmation={confirmation}
                    reservationStatus={reservationStatus}
                    reservationId={reservationId}
                    tripDetailsUrl={tripDetailsUrl}
                />
            );
        }

        if (paymentConfirmation) {
            next = (
                <PaymentSteps
                    translations={translations}
                    tripDetailsUrl={tripDetailsUrl}
                />
            );
        }

        return (
            <div className="NextSteps confirmation-item text-center">
                <div className="row">{next}</div>
            </div>
        );
    }
}
